import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import housecallProLogo from '../../../../assets/logo_housecallpro_banner.png';
import { baseStyleSheet } from '../../../../styles/styles';
import { GenericIntegrationGraphic } from '../../../svgs/graphics/GenericIntegrationGraphic';
import { IntegrationCard, useIntegrationCard } from '../IntegrationCard';
import { housecallProColor, styleSheet } from './styles';

export const DashboardHousecallProIntegrationCard = () => {
	const { getCloseButtonProps, getCtaButtonProps, getIntegrationTitleProps, showCard } = useIntegrationCard({
		closeIntegrationEventName: 'HousecallProIntegrationClosed',
		enableUrlPath: '/integrations/HousecallPro',
		integrationEnableEventName: 'HousecallProIntegrationEnableClick',
		pendingAction: Api.PendingActions.ConnectHousecallPro,
		checkApiPendingAction: true,
	});

	if (!showCard) {
		return null;
	}

	return (
		<IntegrationCard
			closeButtonProps={getCloseButtonProps()}
			IntegrationGraphic={
				<>
					<img src={housecallProLogo} alt='Housecall Pro' className={css(styleSheet.graphic)} />
					<span className={css(styleSheet.integrationGraphic)}>
						<GenericIntegrationGraphic color={housecallProColor} />
					</span>
				</>
			}
			ctaButtonProps={getCtaButtonProps({
				children: 'Connect with Housecall Pro',
				styleDeclaration: [baseStyleSheet.ctaButtonReverse, styleSheet.ctaButton],
			})}
			integrationTitleProps={getIntegrationTitleProps({
				styleDeclaration: styleSheet.integrationTitle,
			})}
		>
			<p>
				We are excited to announce that you can integrate your Housecall Pro account with Levitate. With this
				integration, we will have the ability to pull client information, including names, email, phone number, and more
				&mdash; making staying in touch even easier.
			</p>
		</IntegrationCard>
	);
};
